export default __webpack_public_path__ + "static/media/icon.1b44c4ea.svg";